import { SET_TOKEN, SET_USUARIO } from '../types';

export const setToken = (token) => ({
    type: SET_TOKEN,
    payload: token
});

export const setUsuario = (token) => ({
    type: SET_USUARIO,
    payload: token
});
